export function nowIso() {
  return new Date().toISOString()
}
